import {
  setConstructionPlanAutoCompleteTurn,
  setConstructionPlanInvalidHexKeys,
  showToast
} from "../../../../redux/actions";
import {selectConstructionPlanIsAutoCompleteTurn} from "../../../../redux/reducers/privateStateReducer/selectors";
import {checkIfConstructionPlanningAvailable} from "./getConstructionPlanContext";
import {validateConstructionPlan} from "./validateConstructionPlan";

/**
 * Клик по кнопке «Автоматически завершить ход»:
 *  - чекбокс выставлен — снимается;
 *  - снят — план проверяется (validateConstructionPlan) и невалидное
 *    подсвечивается, как по кнопке завершения фазы. Чекбокс выставляется,
 *    только если невалидного нет.
 * Возвращает {isAutoCompleteTurn, isChanged}: итоговое значение чекбокса и
 * поменялось ли оно.
 */
export const toggleConstructionPlanAutoCompleteTurn = (store) => {
  const state = store.getState();
  if (!checkIfConstructionPlanningAvailable(state)) {
    return {isAutoCompleteTurn: selectConstructionPlanIsAutoCompleteTurn(state), isChanged: false};
  }

  if (selectConstructionPlanIsAutoCompleteTurn(state)) {
    store.dispatch(setConstructionPlanAutoCompleteTurn(false));
    return {isAutoCompleteTurn: false, isChanged: true};
  }

  const validation = validateConstructionPlan(state);
  // Подсветка — итог проверки: валидный план снимает прежние красные молотки
  store.dispatch(setConstructionPlanInvalidHexKeys(validation.invalidHexKeys));
  if (!validation.isValid) {
    store.dispatch(showToast(validation.message, 'warning', 5000));
    return {isAutoCompleteTurn: false, isChanged: false};
  }

  store.dispatch(setConstructionPlanAutoCompleteTurn(true));
  return {isAutoCompleteTurn: true, isChanged: true};
};
